// composables/usePageAutoReload.ts
import {onMounted, onBeforeUnmount} from 'vue'

export function usePageAutoReload(inactiveDuration = 5 * 60 * 1000) {
    const handleVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
            // Lưu thời gian người dùng rời khỏi
            sessionStorage.setItem('lastHidden', Date.now().toString())
        } else if (document.visibilityState === 'visible') {
            const lastHidden = parseInt(sessionStorage.getItem('lastHidden') || '0', 10)
            const now = Date.now()

            if (now - lastHidden > inactiveDuration) {
                window.location.reload()
            }
        }
    }

    onMounted(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange)
    })

    onBeforeUnmount(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange)
    })
}
